import React, {memo, useEffect, useState} from 'react';
import { Dustbin } from './Dustbin.jsx';
import { Box } from './Box.jsx';
import {Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import TimeLineAPng from "../../assets/images/a.png";
import Dropzone from "react-dropzone";
import {uploadImage} from "../../apiHelpers/uploadApiHelper";
import { paramPost } from "../../apiHelpers/commonApiHelper";
import toastr from "toastr";

const DragContainer = memo(function Container(props) {
    const [dragState, setDragState] = useState(false);
    const [stateList, setStateList] = useState([]);
    const [stateVisible, setStateVisible] = useState(false);
    const [loadingState, setLoadingState] = useState(0);
    const [timelineItems, setTimelineItems] = useState([]);
    const [camName, setCamName] = useState(undefined);
    const [layout, setLayout] = useState(undefined);
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        let canvas = document.getElementById("canvasTop");
        let ctx = canvas.getContext("2d");
        let canvas2 = document.getElementById("canvasBottom");
        let ctx2 = canvas2.getContext("2d");
        ctx2.beginPath();
        for (let i = 0; i < canvas.width; i += 20) {
            let y = (i / 200 == parseInt(i / 200)) ? 0 : 10;
            if(y === 0) {
                ctx2.font = "5px";
                let number = 0;
                if(i !== 0) {
                    number = i * 10 /200
                }
                ctx2.fillText(`${number}`, i + 5, 9);
            }
            ctx2.moveTo(i, y);
            ctx2.lineTo(i, 16);
        }
        ctx2.stroke();
    }, [])

    useEffect(() => {
        setCamName(props.name);
        setLayout(props.layout);
    },[props.name, props.layout])

    const selectLayout = (value) => {
        setLayout(parseInt(value));
    }
    const clear = () => {
        setLoadingState(0);
        setStateList([]);
    }

    const stateLists = () => {
        if(stateList.length > 0) {
            return stateList.map((item, index) => {
                return (
                    <li className="file-list-li" key={index}>
                        <Row>
                            <Col xs={10} className="file_name">{item.fileName}</Col>
                            <Col xs={2} className="file-loading">
                                {loadingState === 0 ? (
                                    <i className="fas fa-circle-notch fa-spin"></i>
                                ) : loadingState === 1 ? (
                                    <i className="fas fa-check-circle"></i>
                                ) : (
                                    <i className="fas fa-times-circle text-danger"></i>
                                )}
                            </Col>
                        </Row>
                    </li>
                )
            })
        }
    }

    const addFileToTimeline = (value) => {
        const payload = { id: value.id || value.file_id, duration: value.duration, file_name: value.file_name || value.name };
        setTimelineItems((prev) => [...prev, payload]);
    }

    const removeTimelineItem = (index) => {
        setTimelineItems((prev) => prev.filter((_, itemIndex) => itemIndex !== index));
    }

    const moveTimelineItem = (fromIndex, toIndex) => {
        if (toIndex < 0) return;
        setTimelineItems((prev) => {
            if (toIndex >= prev.length) return prev;
            const clone = [...prev];
            const [moved] = clone.splice(fromIndex, 1);
            clone.splice(toIndex, 0, moved);
            return clone;
        });
    }

    const totalTimelineDuration = timelineItems.reduce((acc, item) => acc + (parseInt(item.duration, 10) || 0), 0);

    const mediaList = () => {
        if(props.media.length > 0) {
            return props.media.map((item, index) => {
                return (
                    <Col xs={6} sm={4} md={3} lg={2} className="mb-3" key={index}>
                        <Box info={item} onDropToTimeline={addFileToTimeline} />
                    </Col>
                )
            })
        }
    }

    const handleAcceptedFiles = (files) => {
        clear();
        setStateVisible(true);
        setLiLists(files);
        setDragState(false);
        const formData = new FormData();
        files.forEach((image, index) => {
            formData.append(`image[${index}]`, image);
        });
        uploadFile(formData);
    }

    const handleDragState = (value) => {
        setDragState(value)
    }

    const uploadFile = (data) => {
        uploadImage("/api/v1/upload_images", data)
            .then((result) => {
                if(result.status === 201) {
                    setLoadingState(1);
                    hideResult();
                    props.getMedia(true);
                } else {
                    setLoadingState(2);
                    hideResult();
                }
            })
            .catch((err) => {
                setLoadingState(2);
                hideResult();
            })
    }

    const hideResult = () => {
        setTimeout(() => {
            setStateVisible(false);
        }, 2000);
    }
    const setLiLists = (values) => {
        values.forEach((item) => {
            setStateList(stateList => [...stateList, {fileName: item.name}]);
        })
    }

    const handlePublish = () => {
        if(!camName){
            toastr.warning("Please input campaign name", "Warning");
            return false
        }
        if(timelineItems.length < 1) {
            toastr.warning("Please select video or images files to publish your campaign", "Warning");
            return false
        }
        setProcessing(true);
        const files = timelineItems.map((item) => ({ id: item.id, duration: item.duration }));
        paramPost('api/v1/campaigns', {name: camName, layout: layout, files})
            .then((result) => {
                setProcessing(false);
                if(result.status === 201) {
                    toastr.success(result.data.message, "Success");
                    setTimeout(() => {
                        window.location.href = "/saved_campaigns";
                    }, 1500)
                } else {
                    toastr.error("Soemthing went wrong. Please try again", "Error");
                }
            })
            .catch((err) => {
                setProcessing(false);
                toastr.error("Soemthing went wrong. Please try again", "Error");
            })
    }

    return (<React.Fragment>
        <Row>
            <Col sm={12}>
                <Card className="card-style">
                    <CardHeader>Timeline</CardHeader>
                    <CardBody style={{paddingTop: "0px"}}>
                        {/*<Row className="panel-ruler" id="wrapper">*/}
                        {/*    <canvas id="canvasTop"></canvas>*/}
                        {/*    <canvas id="canvasBottom"></canvas>*/}
                        {/*</Row>*/}
                        <div id="wrapper">
                            <canvas id="canvasBottom" width={850} height={15}></canvas>
                            <canvas id="canvasTop" width={850} height={0}></canvas>
                        </div>
                        <Row className="time-line" style={{overflowX: "auto", whiteSpace: "nowrap"}}>
                            <Col xs={1.5} className="media-left" style={{width: "118px", boxShadow: "5px 0 5px -3px #888"}}>
                                <img src={TimeLineAPng} alt={" "} width={96} />
                            </Col>
                            <Dustbin items={timelineItems} onRemove={removeTimelineItem} onMove={moveTimelineItem} />
                        </Row>
                        <div className="mt-2 text-right font-size-13 text-muted">
                            Total Duration: <strong>{totalTimelineDuration}s</strong> ({Math.ceil(totalTimelineDuration / 60)} min)
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
        <Row>
            <Col sm={12}>
                <Card className="card-style">
                    <CardHeader>Content</CardHeader>
                    <CardBody>
                        <Row>
                            <Dropzone
                                onDrop={acceptedFiles => { handleAcceptedFiles(acceptedFiles) }
                                }
                                onDragEnter={() => handleDragState(true)}
                                onDragLeave={() => handleDragState(false)}
                                maxSize={5000000}
                                noClick={true}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <div className="dropzone" style={{width: "100%"}}>
                                        {!dragState ? (
                                            <div
                                                className="dz-message needsclick mt-2"
                                                style={{height: "100%"}}
                                                {...getRootProps()}
                                            >
                                                <input {...getInputProps()} />
                                                <Row>
                                                    {mediaList()}
                                                </Row>
                                            </div>
                                        ) : (
                                            <div
                                                className="dz-message needsclick mt-2"
                                                style={{height: "100%"}}
                                                {...getRootProps()}
                                            >
                                                <input {...getInputProps()} />
                                                <div className="mb-3">
                                                    <i className="display-4 text-muted bx bxs-cloud-upload"></i>
                                                </div>
                                                <h4>Drop files here.</h4>
                                                <p style={{ fontSize: "13px" }}>Upload video or image files.</p>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Dropzone>
                        </Row>
                        {stateVisible && (
                            <div className="bottom-notification">
                                <Row>
                                    <Col className="text-right close-btn">
                                        <i className="mdi mdi-close-circle" onClick={() => setStateVisible(false)}></i>
                                    </Col>
                                </Row>
                                <Row className="file-list-div">
                                    <Col>
                                        <ul>
                                            {stateLists()}
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                        )}

                    </CardBody>
                </Card>
            </Col>
        </Row>
        <div className="publish-row">
            <div className="state-save">
                {/*<button className="btn btn-primary">Preview</button>*/}
                <button className="btn btn-orange" onClick={() => handlePublish()}>
                    {!processing ? "Save Campaign" : (
                        <React.Fragment>
                            <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                            Saving
                        </React.Fragment>
                    )}
                </button>
            </div>
        </div>
    </React.Fragment>);
});

export default DragContainer;